import { __spreadArray } from 'tslib';
import React__default, { useState, useMemo, useEffect, Fragment } from 'react';
import { useCurrentUi, useBasketListPaginated } from '@keepeek/commons';
import { TextField, Grid, Box, Skeleton } from '@mui/material';
import debounce from 'lodash/debounce';
import { useTranslation } from 'react-i18next';
import BasketCard from '../../Basket/BasketCard/index.js';
import { withSuspense } from '../../withSuspense/index.js';
import BasketsEmptyState from '../BasketsEmptyState/index.js';

var KFBasketsList = function KFBasketsList(_a) {
    var _b;
    var onBasketClick = _a.onBasketClick, KIcon = _a.KIcon, searchInput = _a.searchInput, _c = _a.onlyOwnBasketsParam, onlyOwnBasketsParam = _c === void 0 ? true : _c, _d = _a.activateBasketPartitioning, activateBasketPartitioning = _d === void 0 ? false : _d, searchInputRenderLayout = _a.searchInputRenderLayout;
    var t = useTranslation("refront-components").t;
    var _e = useState(""), queryFilter = _e[0], setQueryFilter = _e[1];
    var _f = useState(""), valueQ = _f[0], setValueQ = _f[1];
    var currentUi = useCurrentUi().currentUi;
    var basketList = useBasketListPaginated({
        sortParam: "creationDate desc",
        sizeParam: 100,
        qParam: queryFilter,
        fqParam: __spreadArray(__spreadArray([], (onlyOwnBasketsParam ? ["permission:ADMIN"] : []), true), (activateBasketPartitioning ? ["uiId:".concat(currentUi === null || currentUi === void 0 ? void 0 : currentUi.id)] : []), true)
    }).basketList;
    var debounced = useMemo(function () {
        return debounce(function (value) {
            setQueryFilter(value);
        }, 300);
    }, [setQueryFilter]);
    useEffect(function () {
        debounced(valueQ);
        return function () {
            debounced.cancel();
        };
    }, [debounced, valueQ]);
    var inputSearchComponent = (React__default.createElement(TextField, { placeholder: t("components.kfbasketsList.actions.search.placeholder.label"), variant: "outlined", fullWidth: true, value: valueQ, onChange: function (e) { return setValueQ(e.currentTarget.value); }, InputProps: {
            endAdornment: React__default.createElement(KIcon, { className: "fa-solid fa-magnifying-glass " })
        } }));
    var searchInputLayout = searchInputRenderLayout ? (searchInputRenderLayout(inputSearchComponent)) : (React__default.createElement(Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" },
        React__default.createElement(Grid, { item: true, xs: 11, sm: 8, md: 7, lg: 6, xl: 5 },
            React__default.createElement(Box, null, inputSearchComponent))));
    if (basketList.totalCount === 0) {
        return (React__default.createElement(React__default.Fragment, null,
            searchInput && searchInputLayout,
            React__default.createElement(BasketsEmptyState, { testId: "BasketsEmptyState", hasFilters: false, resetFilters: function () { } })));
    }
    return (React__default.createElement(React__default.Fragment, null,
        searchInput && searchInputLayout,
        React__default.createElement(Box, { component: "ol", sx: {
                padding: 0,
                margin: 0,
                listStyle: "none",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center"
            }, display: "flex", gap: 2, "data-testid": "KFBasketsList" }, (_b = basketList.baskets) === null || _b === void 0 ? void 0 : _b.map(function (basket) { return (React__default.createElement(Box, { component: "li", key: basket.id, sx: {
                minWidth: { xs: "280px", sm: "320px" },
                maxWidth: { xs: "280px", sm: "100%" }
            } },
            React__default.createElement(Fragment, null,
                React__default.createElement(BasketCard, { onClick: onBasketClick ? function () { return onBasketClick(basket); } : undefined, sx: {
                        borderRadius: "6px",
                        border: "1px solid",
                        borderColor: function (theme) { return theme.palette.primary.main; },
                        "& .BasketCard-title": {
                            fontWeight: "bold"
                        }
                    }, image: basket.media, title: basket.title, count: basket.mediaCount, KIcon: KIcon })))); }))));
};
var BasketsWidgetListLoading = function () {
    return (React__default.createElement(Box, { component: "ol", sx: {
            padding: 0,
            margin: 0,
            listStyle: "none",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "center"
        }, display: "flex", gap: 2 }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(function (_, i) { return (React__default.createElement(Box, { component: "li", key: i, sx: { minWidth: function (theme) { return theme.spacing(40); }, maxWidth: "100%" } },
        React__default.createElement(Skeleton, { height: "244px" }))); })));
};
var index = withSuspense(KFBasketsList, { LoadingComponent: BasketsWidgetListLoading });

export { index as default };
//# sourceMappingURL=index.js.map
